import { useTranslation } from 'react-i18next'
import moment from 'moment'
import { find, propEq } from 'ramda'

import CurrencyFormatter from '@/components/currency-formatter'
import getPriceDateOptions from '@/utils/price-date-options'
import {
  ContentWrapper,
  AreaTitle,
  StyledPanel,
  StyledRow,
  StyledLabel,
  StyledValue
} from './elements'
import { PaymentData } from '../types'

type PaymentRecurringProps = {
  paymentData: PaymentData
  listingId: string
}

const PaymentRecurring: React.FC<PaymentRecurringProps> = ({ paymentData }) => {
  const { description, requested_amount, additional_fee, pad_agreement } = paymentData
  const firstPaymentDate = pad_agreement?.first_payment_on ?? ''
  const { t } = useTranslation()
  const priceDateOptions = getPriceDateOptions(t)
  const formattedDate = `price_date_${moment(firstPaymentDate).date()}`
  const selectedDateOption = find(propEq('value', formattedDate), priceDateOptions) || {
    label: ''
  }

  return (
    <>
      <ContentWrapper top={46}>
        <AreaTitle>
          {t('b.payment.view.pad_payment_requests.title', 'PAD Payment Requests')}
        </AreaTitle>
        <StyledPanel hSpace={24} vSpace={24}>
          <StyledRow bottom={20}>
            <StyledLabel>{t('b.payment.view.detail.label', 'Detail')}</StyledLabel>
            <StyledValue>{description}</StyledValue>
          </StyledRow>
          <StyledRow bottom={20}>
            <StyledLabel>{t('b.payment.view.payment_method.label', 'Payment Method')}</StyledLabel>
            <StyledValue>PAD (Pre-Authorized Debit)</StyledValue>
          </StyledRow>
          <StyledRow bottom={20}>
            <StyledLabel>{t('b.payment.view.rent_price.label', 'Rent price')}</StyledLabel>
            <StyledValue>
              <CurrencyFormatter value={requested_amount} showCents />
            </StyledValue>
          </StyledRow>
          <StyledRow bottom={20}>
            <StyledLabel>{t('b.payment.view.additional_fee.label', 'Additional Fee')}</StyledLabel>
            <StyledValue>
              <CurrencyFormatter value={additional_fee} showCents />
            </StyledValue>
          </StyledRow>
          <StyledRow bottom={20}>
            <StyledLabel>
              {t('b.payment.view.payment_frequency.label', 'Payment Frequency')}
            </StyledLabel>
            <StyledValue>{t('b.payment.view.monthly.label', 'Monthly')}</StyledValue>
          </StyledRow>
          <StyledRow bottom={0}>
            <StyledLabel>{t('b.payment.view.payment_date.label', 'Payment Date')}</StyledLabel>
            <StyledValue>{selectedDateOption?.label}</StyledValue>
          </StyledRow>
        </StyledPanel>
      </ContentWrapper>
    </>
  )
}

export default PaymentRecurring
